module.exports = __webpack_public_path__ + "static/media/003-plaque.28c38ebd.svg";